import type { UserRole } from '@mss_creator/shared';

/**
 * Client-side mirror of the backend's `assertCanMutateCompany`
 * (`packages/backend/src/routes/company.ts`): `pms_user` and `pms_admin` may
 * edit any company, `admin` only the company they belong to, `user` none.
 * Only decides what the UI offers; the server still enforces it.
 */
export function canMutateCompany(
  role: UserRole | undefined,
  membershipCompanyId: string | null | undefined,
  companyId: string,
): boolean {
  if (role === 'pms_user' || role === 'pms_admin') return true;
  if (role === 'admin') return membershipCompanyId === companyId;
  return false;
}

/**
 * Who may archive, restore and permanently delete companies, and see the
 * archives (issue #20): the two global roles only, as on the backend — an
 * `admin` client cannot archive even their own company. Only decides what the
 * UI offers; the server still enforces it.
 */
export function canManageCompanies(role: UserRole | undefined): boolean {
  return role === 'pms_user' || role === 'pms_admin';
}
